import React from 'react';
import PropTypes from 'prop-types';

import {
    black500,
    greyishBlue50,
    greyishBlue500
} from "assets/jss/main";

PageTitle.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    isDesktop: PropTypes.bool
};

function PageTitle({title, subtitle, isDesktop = false, customPadding}) {
    return (
        <div style={{
            padding: customPadding ? customPadding : isDesktop ? '8px' : '24px 16px',
            backgroundColor: isDesktop ? "transparent" : greyishBlue50
        }}>
            <div style={{
                fontSize: '20px',
                fontWeight: 600,
                color: black500,
            }}>
                {title}
            </div>
            <div style={{
                fontSize: '14px',
                fontWeight: 400,
                color: greyishBlue500,
            }}>
                {subtitle}
            </div>
        </div>
    );
}

export default PageTitle;
